module.exports = __webpack_public_path__ + "static/bg_084_geoda_ametist-65cf8e9b05666d0fc3bc08df4c4b723e.webp";